import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { markQuickActionsReady } from '@/lib/capacitorQuickActions';
import { logger } from "@/lib/logger";

/**
 * Listens for `cap-shortcut` custom events dispatched by
 * capacitorQuickActions and navigates inside the React Router context.
 */
export function useQuickActionNavigator(): void {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e: Event) => {
      const route = (e as CustomEvent<string>).detail;
      if (route) {
        logger.log('[Shortcuts] route consumed by router |', route);
        navigate(route);
      }
    };

    window.addEventListener('cap-shortcut', handler);
    logger.log('[Shortcuts] router ready');
    markQuickActionsReady().catch((e) => {
      logger.log('[Shortcuts] markQuickActionsReady error', e);
    });

    return () => window.removeEventListener('cap-shortcut', handler);
  }, [navigate]);
}
